import i18next from '@/i18n';

export const MSG_ERROR_REQUIRED_FIELD = i18next.t('validation.required');
